import Web3 from 'web3';
import useAppStore from '../stores/appStore';
import { toNormalFixed } from '../utils';
import { ethers } from 'ethers';
import { useWeb3Connect } from '../contexts/Web3ProviderContext';
import { useCallback } from 'react';
import { useContract } from './useContract';
import { ERC20_TOKEN_ADDRESS } from '../contracts/erc20';
import ERC20_ABI from '../contracts/erc20/Erc20ABI.json';

export const useGetUserBalance = () => {
  const { account, isEthChainConnected } = useWeb3Connect();
  const tokenContract = useContract(ERC20_TOKEN_ADDRESS, ERC20_ABI);

  return useCallback(async () => {
    if (account && Web3.givenProvider && isEthChainConnected !== undefined) {

      if (!isEthChainConnected) {
        const balanceBg = await Web3.givenProvider.request({ method: 'eth_getBalance', params: [account, 'latest'] });
        useAppStore.setState({
          userBalance: toNormalFixed(ethers.utils.formatUnits(balanceBg, 18), 4),
        });
      } else {
        if (tokenContract) {
          const balanceBg = await tokenContract.methods.balanceOf(account).call();
          const decimals = await tokenContract.methods.decimals().call();

          useAppStore.setState({
            userBalance: toNormalFixed(ethers.utils.formatUnits(balanceBg, +decimals), 4),
          });
        }
      }
    }
  }, [account, isEthChainConnected, tokenContract]);
};
